import { env } from 'utils/envManager'

import type { ImageLoaderProps } from '../../types/types'
import { getImageHeight } from '../../utils/getImageHeight/getImageHeight'
import { getImageWidth } from '../../utils/getImageWidth/getImageWidth'

export const legacySmartCropLoader = ({ src, width }: ImageLoaderProps) => {
	const viewportWidth = getImageWidth(width)
	const viewportHeight = getImageHeight({ width: viewportWidth })

	const url = new URL(src, env.NEXT_PUBLIC_SITE_BASE_URL)

	const previousAssetsTs = url.searchParams.get('ts')

	const searchParams = new URLSearchParams()

	if (previousAssetsTs) {
		searchParams.append('ts', previousAssetsTs)
	}

	searchParams.append(
		'im',
		`SmartCrop,width=${viewportWidth},height=${viewportHeight}`
	)
	searchParams.append('imdensity', '1')

	url.search = decodeURIComponent(searchParams.toString())

	return url.toString()
}
